import service from '../services/request'

// 完善用户信息
export const saveInfo = function (data) {
  return service({
    method: 'post',
    url: '/user/verify',
    data
  })
}

// 发送验证码
export const getMessageCode = function (params) {
  return service({
    method: 'get',
    url: '/user/sendMessage',
    params
  })
}

// 获取用户基本信息
export const getUserByOpenid = function (params) {
  return service({
    method: 'get',
    url: '/user/getUserByOpenid',
    params
  })
}

// 检查用户信息
export const checkUserInfo = function (params) {
  return service({
    method: 'get',
    url: '/weixin/getUserInfo',
    params
  })
}

// 获取用户红包列表
export const getRewardList = function (params) {
  return service({
    method: 'get',
    url: '/awardLog/getAwardList',
    params
  })
}
// 更新用户信息 
export const updateUser = function (data) {
  return service({
    method: 'post',
    url: '/user/updateUser',
    data
  })
}